import { render } from "./createUsersComponent.vue?vue&type=template&id=6ddaa7ba&scoped=true"
import script from "./createUsersComponent.vue?vue&type=script&lang=js"
export * from "./createUsersComponent.vue?vue&type=script&lang=js"

import "./createUsersComponent.vue?vue&type=style&index=0&id=6ddaa7ba&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddaa7ba"]])

export default __exports__